import {connect} from "react-redux";
import AvailabilityPanelSet from "./AvailabilityPanelSet";
import * as ShippingApiActions from "../../actions/ShippingApiActions";
import * as SelectionActions from "../../actions/SelectionActions";
import * as ViewActions from "../../actions/ViewActions";
import {getSelection} from "../../reducers/selectionReducer";
import {getAvailabilityFilter, getAvailabilityWithComposedId} from "../../reducers/shippingReducer";

function mapStateToProps(state) {
  const context = "availability";
  const selection = getSelection(state.get("selection"), context);  
  return {
    context: context,
    availabilityFilter: getAvailabilityFilter(state.get("shipping")),
    selectedAvailability: getAvailabilityWithComposedId(state.get("shipping"), selection),
    selection: selection,
    hasSelection: selection !== ""
  }
}

export default connect(mapStateToProps, {...ShippingApiActions, ...SelectionActions, ...ViewActions})(AvailabilityPanelSet);